// PopupCard.js
import React from 'react';
import './PopupCard.css';

const PopupCard = ({ active, onClose }) => {
  return (
    <div className={`popup-card ${active ? 'active' : ''}`}>
      <div className="card-content">
        <h3>About Us:</h3>
        <p>
          Welcome to WeaponSense, where innovation meets security. We are at the forefront of revolutionizing security measures through our cutting-edge Weapon Recognition System. Our mission is simple yet profound: to enhance security measures through innovative technology, utilizing AI and computer vision for accurate weapon identification. In today's rapidly evolving security landscapes, our system addresses the critical need for advanced threat detection, contributing to the safety and well-being of individuals and communities worldwide.
        </p>
        <h3>CONCEPT OF THE PROJECT</h3>
        <p>
          At WeaponSense, our proposed implementation focuses on accurate gun detection and classification, emphasizing precision and real-time detection of weapons. We are committed to ensuring the highest level of accuracy and efficiency in identifying potential threats. Our system creates a bounding box before detecting objects, enabling swift and accurate identification. In the event of a threat, our system is designed to send alerts to authorities promptly, allowing for proactive measures to tackle the situation effectively.
        </p>
        <h3>PROBLEM STATEMENT</h3>
        <p>
          The need for advanced threat detection has never been more pressing. That's why at WeaponSense, we are dedicated to developing an AI-driven Weapon Recognition System for instant weapon detection in images and videos. Our goal is to enable seamless data transmission to defense services, empowering them to proactively counter threats and safeguard public safety.
        </p>
        <h3>OBJECTIVES</h3>
        <ul>
          <li>
            <strong>Develop Accurate Weapon Detection</strong>: Our primary objective is to develop a weapon detection system that is highly accurate and reliable, ensuring the timely identification of potential threats.
          </li>
          <li>
            <strong>Adaptability to Diverse Weapons</strong>: We aim to create a system that is adaptable to diverse types of weapons, including firearms, knives, and other dangerous objects.
          </li>
          <li>
            <strong>Instant Weapon Detection, Real-time Intel for Defense</strong>: Our system is designed to provide instant weapon detection and real-time intelligence for defense purposes, enabling swift and effective response to security threats.
          </li>
        </ul>
        <p>
          At WeaponSense, we are committed to leveraging technology to create a safer and more secure environment for all. Join us in our mission to revolutionize security measures and protect communities from potential harm.
        </p>
      </div>
    </div>
  );
};

export default PopupCard;
